module.exports = __webpack_public_path__ + "img/dataPark2.50e3bd64.png";